import { RouteErrorFallback } from '@/components/shared/route-error-fallback';
import { RouteNotFound } from '@/components/shared/route-not-found';
import { reportRouteError } from '@/lib/sentry';

// Spread into `createRouter`. Setting both is what installs a `CatchBoundary` per route match.
export const routeErrorHandling = {
  defaultErrorComponent: RouteErrorFallback,
  defaultOnCatch: reportRouteError,
  defaultNotFoundComponent: RouteNotFound,
};
